<div *ngIf="isSidebarAvailable">
	<div class="cui__sidebar" [ngClass]="isSidebarOpen ? 'cui__sidebar__toggled' : ''">
		<perfect-scrollbar>
			<div class="cui__sidebar__inner">
				<a href="javascript: void(0);" class="cui__sidebar__close" (click)="closeSideBar()">
					<i-feather name="x-circle"></i-feather>
				</a>

				<app-template-sidebar *ngIf="showSidebarTemplate"></app-template-sidebar>
				<app-developer-sidebar *ngIf="showSidebarDevelop"></app-developer-sidebar>

			</div>
		</perfect-scrollbar>
	</div>

	<app-floating-button *ngIf="showDocumentationBtn"
			[btnIcon]="'book-open'" [btnTitle]="'misc.documentation'" [btnLink]="'https://docs.cleanuitemplate.com'"
			[btnPosition]="0">
	</app-floating-button>

	<app-floating-button *ngIf="showDeveloperSettingsBtn"
			[btnIcon]="'activity'" [btnTitle]="'misc.developer_settings'" (btnClick)="toggleSidebarDevelop()" [btnPosition]="1">
	</app-floating-button>

	<app-floating-button *ngIf="showDevTogglingBtn"
			[btnIcon]="demoModeIcon" [btnTitle]="'misc.demo_mode'" (btnClick)="toggleDemo()" [btnPosition]="2">
	</app-floating-button>
</div>
